<template>
  <div
    class="pop-600 text-small wrap-50px bl-color noselect pointer"
    :style="styleCustom"
    @click="openFixationPopUp"
  >
    {{ title }}
  </div>
</template>

<script>
export default {
  name: "FixationChooseHandler",
  props: {
    title: String,
    rules: [Array, null],
    styleCustom: String,
  },
  methods: {
    openFixationPopUp () {
      this.$store.commit("popupManagerState/pushToPopupOrder", {
        type: null,
        payload: null,
        component: "FixationChoosePopUp",
        rules: this.rules,
      });
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
